module.exports = __webpack_public_path__ + "static/media/curso-ladder-treinamentos-landing-page-estatico-768x591.da227bf8.jpg";